<template>
  <div>
    <div class="inst-title">갇힌 공간 검사</div>
    <pre class="inst-desc">
모델에 갇힌 공간이 존재할 경우,
      · 공구가 들어가지 않아 가공할 수 없거나
      · 제조하고 남은 재료들을 제거하지 못할 수 있습니다.</pre
    >

    <div class="inst-subtitle">[해결방법]</div>

    <pre class="inst-desc">초기 설계 단계에서 여러 파트로 구성 한 뒤 조립</pre>
  </div>
</template>

<script setup></script>
